// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectButton_wrapper__JTIyg","active":"SelectButton_active__jjRI9","dark":"SelectButton_dark__gAyAO"};